module.exports = __webpack_public_path__ + "img/contact-logo.c10fe90e.png";